import Store from "@/store";

//Display company name with input companyId
export default (companyId: number): string => {
  const company = Store.getters["Companies/companyById"](companyId);
  return company ? company.name : "";
};
